import { useParams } from 'react-router-dom'
import { useTitle } from 'react-use'
import { find } from 'lodash-es'
import { LoadingIndicator } from '@ui/feedback'
import { Viewer } from '@editorComponents'
import usePlansQuery from '../Editor/pages/Plans/hooks/usePlansQuery'

const emptyArray: Plan[] = []

const PlanViewer = () => {
  const { planId } = useParams<{ projectId: string; planId: string }>()

  const { data: plans = emptyArray, isLoading: isLoadingPlans } = usePlansQuery()

  const selectedPlan = find(plans, plan => plan.guid === planId)

  useTitle(selectedPlan?.node_name || 'Plan Viewer')

  if (isLoadingPlans || !selectedPlan) return <LoadingIndicator />

  return (
    <Viewer
      document={
        selectedPlan
          ? {
              guid: selectedPlan.guid,
              name: selectedPlan.node_name,
              url: selectedPlan.url as string,
              fileType: 'application/pdf',
            }
          : null
      }
      isAdmin={false}
      viewerHeight="100vh"
    />
  )
}

export default PlanViewer
